// eslint-disable-next-line
import { Container, Row, Col } from "react-bootstrap";
import { Navbar, Nav } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import "./footer.css";
import mailIcon from "../../Assets/mailIcon.png";

const Footer = ({ isHrTag }) => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      {isHrTag && <hr className="footer_horizontal_line" />}
      <footer className="text-center" >
        <div className="container pt-1">
          <div className="row">
            <div className="col-md-12 footer-section">
              <p className="m-0 mail-footer">
                <img src={mailIcon} alt="mail icon" height={15} width={16.85} />
                <a href="mailto:alokfab@alokfab.in" className="copyrighttxt">
                  alokfab@alokfab.in
                </a>
              </p>
              <p className="m-0 copyrighttxt">© {currentYear} Alok Fabrications. All rights reserved.</p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
